<script lang="ts">
	// eslint-disable-next-line import-x/no-duplicates
	import { cubicOut } from 'svelte/easing'
	// eslint-disable-next-line import-x/no-duplicates
	import { Tween } from 'svelte/motion'

	import { n } from '#lib/utils/navigation.svelte.js'

	const progress = new Tween(0, { easing: cubicOut })
	const opacity = new Tween(1, { easing: cubicOut })

	$effect(() => {
		if (n.l) {
			opacity.set(1, { duration: 0 })
			progress.set(0.7, { duration: 3500 })
		} else {
			const duration = 1000

			opacity.set(0, { duration: duration / 2, delay: duration / 2 })
			progress.set(1, { duration })

			setTimeout(() => progress.set(0, { duration: 0 }), duration)
		}
	})
</script>

<!-- eslint-disable-next-line svelte/no-inline-styles -->
<div style:opacity={opacity.current} class="pointer-none fixed top-0 right-0 left-0 z-15 h-1">
	<!-- eslint-disable-next-line svelte/no-inline-styles -->
	<div style:width="{progress.current * 100}%" class="bg-branding-blue h-full"></div>
</div>
